import Head from 'next/head';

//#region [Props]
type FilmQuizSeoProps = {
};
//#endregion

//#region [Component]
export default function FilmQuizSeo({ }: FilmQuizSeoProps) {
	return <Head>
		<meta key="ogTitle" property="og:title" content="Filmquiz" />


		<meta key="ogDescription" name="og:description" content="Velkommen til Filmwebs filmquiz! Svar på så mange spørsmål du klarer. Ved 3 gale svar avsluttes quizen. Spill Filmwebs filmquiz!" />
		<meta key="metaDescription" name="description" content="Velkommen til Filmwebs filmquiz! Svar på så mange spørsmål du klarer. Ved 3 gale svar avsluttes quizen. Spill Filmwebs filmquiz!"/>
		<meta key="metaTitle" name="title" content="Filmquiz - Filmweb" />

		<title key="title">Filmquiz - Filmweb</title>
	</Head>;
}
//#endregion
